import React from 'react'
import Header from '../../../Components/Header'
import Footer from '../../../Components/Footer'

const CancellationPolicy = () => {
    return (
        <>
            <Header />
            <h6>Cancellation Policy Page</h6>
            <Footer />
        </>
    )
}

export default CancellationPolicy
